import { apis } from "@/modules/apiClients"
import { workTimeAtom } from "@/store/saveWorkAtoms"
import { useSetAtom } from "jotai"
import _ from "lodash"
import { useCallback, useEffect } from "react"

const eventsToReport = ['focus', 'mousemove', 'keydown', 'scroll', 'focusin']

export const useWorkTimeReporting = (challengeId: string | null) => {
  const setWorkTime = useSetAtom(workTimeAtom)

  const report = useCallback(_.throttle(async () => {
    if (!challengeId) return
    // Fire-and-forget telemetry: a failed report (e.g. transient offline) is benign and
    // self-corrects on the next activity tick. Swallow it so it doesn't surface as an
    // unhandled rejection in Sentry.
    try {
      const { data } = await apis.challengeService.reportWorkTime({ challengeId })
      if (data.workTime) {
        setWorkTime(data.workTime)
      }
    } catch {
      // ignore — work-time reporting is non-critical
    }
  }, 60_000), [challengeId])

  useEffect(() => {
    // Only add listeners if we have a challengeId
    if (!challengeId) {
      return
    }

    // Add event listeners
    eventsToReport.forEach(event => {
      window.addEventListener(event, report)
    })

    // Cleanup function - this runs when challengeId changes OR component unmounts
    return () => {
      eventsToReport.forEach(event => {
        window.removeEventListener(event, report)
      })
    }
  }, [report, challengeId]) // This effect re-runs when challengeId changes
}